
async function fetchHolidays() {
  const response = await fetch('https://www.gov.uk/bank-holidays.json');
  const data = await response.json();
  // Assuming you're interested in holidays in England and Wales
  const holidays = data['england-and-wales'].events.map(event => event.date);
  return holidays;
}

async function addWorkingDays(startDate, daysToAdd) {
let holidays = await fetchHolidays();
let currentDate = new Date(startDate);

holidays = holidays.map(holiday => new Date(holiday).getTime()); // Convert holiday strings to Date objects for comparison

while (daysToAdd > 0) {
    currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    let dayOfWeek = currentDate.getDay();

    // Check if it's a weekend or a holiday
    if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(currentDate.getTime())) {
        daysToAdd--; // It's a working day, decrement the counter
    }
}

let day = currentDate.getDate();
let suffix = getDaySuffix(day); // Get the day suffix

// Format the date parts
let weekday = currentDate.toLocaleDateString('en-GB', { weekday: 'long' });
let month = currentDate.toLocaleDateString('en-GB', { month: 'long' });

// Return an object containing the date parts
return {
    weekday: weekday,
    day: day,
    suffix: suffix,
    month: month
};
}

// Function to get day suffix
function getDaySuffix(day) {
if (day >= 11 && day <= 13) {
    return 'th'; // For 11th, 12th, and 13th, use 'th'
}
switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
}
}


(async () => {
let startDate = new Date(); // Today's date
let workingDaysFromNow = await addWorkingDays(startDate, 3);

// Join the date parts together in the desired order
let formattedDate = `${workingDaysFromNow.weekday}, ${workingDaysFromNow.day}${workingDaysFromNow.suffix} ${workingDaysFromNow.month}`;

// console.log("Formatted date:", formattedDate);
let deliveryEtaContainer = document.querySelectorAll(`#delivery-${section_Id} .delivery-eta`);
deliveryEtaContainer.forEach(element => {
  element.textContent = formattedDate;
});

})();
